import React, { FC, useState } from "react";
import {
  Button,
  Form,
  InputGroup,
  FormControl,
  Collapse
} from "react-bootstrap";
import {
  DirectionsRun,
  KeyboardArrowLeft,
  PendingActions,
  SpaceDashboard,
  Stadium,
  Tune
} from "@mui/icons-material";
import { SearchFilterProp } from "./SearchFilter.interface";
import "./SearchFilter.styles.css";
import { Venue } from "types/interfaces/Venue";
import { useVenues } from "modules/venues/hooks";
import { useMediaQuery } from "react-responsive";

export const SearchFilter: FC<SearchFilterProp> = ({
  sport,
  venue,
  category,
  toDate,
  fromDate,
  onCategoryChange,
  onSportChange,
  onVenueChange,
  onFromDateChange,
  onToDateChange
}) => {
  const [collapsed, setCollapsed] = useState({
    sport: false,
    region: false,
    category: false,
    date: false,
    venue: false
  });

  const { venues } = useVenues();

  const isSmallScreen = useMediaQuery({ query: '(max-width: 576px)' });
  const [toggleFilter, setToggleFilter] = useState(isSmallScreen ? false : true);


  const handleGroupCollapse = (group: keyof typeof collapsed) =>
    setCollapsed((current) => ({ ...current, [group]: !current[group] }));

  const resetFilters = () => {
    onSportChange(undefined);
  };

  const handleToggleFilter = () => {
    setToggleFilter(!toggleFilter);
  };

  console.log(isSmallScreen)

  return (
    <div className="sidebar-wrapper">
      <div
        className="sidebar-button sidebar-btn"
        onClick={() => handleToggleFilter()}
      >
        <Tune />
      </div>

      <div
        className="sidebar-container"
        style={{
          width: toggleFilter ? "250px" : "50px",
          backgroundColor: "transparent"
        }}
      >
        <div
          className="sidebar active"
          style={{ left: toggleFilter ? "0px" : "-250px" }}
        >
          <div className="sidebar-header">
            <div className="sidebar-icon">
              <h4>
                <Tune />
                <span className="filter-text">Filter</span>
              </h4>
            </div>
            <Button
              variant="primary"
              className="reset-btn"
              onClick={resetFilters}
            >
              Reset
            </Button>
          </div>

          {/* Filter by Sports */}
          <div className="filter-group">
            <div
              className="filter-btn"
              onClick={() => handleGroupCollapse("sport")}
            >
              <DirectionsRun />
              <h4>Select Sports</h4>
              <KeyboardArrowLeft
                className="chevron"
                style={{
                  transform: collapsed.sport ? "rotate(-90deg)" : "unset"
                }}
              />
            </div>

            <Collapse in={collapsed.sport}>
              <div>
                <div className="filter-content">
                  <Form.Check
                    type="radio"
                    label="All Sports"
                    checked={!sport}
                    onClick={() => onSportChange(undefined)}
                  />
                  {[
                    "basketball",
                    "volleyball",
                    "icehockey",
                    "soccer",
                    "baseball"
                  ].map((sportOption) => (
                    <Form.Check
                      key={sportOption}
                      type="radio"
                      value={sportOption}
                      label={sportOption === 'icehockey' ? 'ICE HOCKEY' : sportOption.toUpperCase()}
                      checked={sport === sportOption}
                      onClick={() => onSportChange(sportOption)}
                    />
                  ))}
                </div>
              </div>
            </Collapse>
          </div>

          {/* Filter by Region */}
          {/* <div className='filter-group'>
            <div
              className='filter-btn'
              onClick={() => handleGroupCollapse('region')}>
              <Landscape />
              <h4>Region</h4>
              <KeyboardArrowLeft
                className='chevron'
                style={{
                  transform: collapsed.region ? 'rotate(-90deg)' : 'unset'
                }}
              />
            </div>

            <Collapse in={collapsed.region}>
              <div>
                <div className='filter-content-wide'>
                  <Form.Check
                    type='radio'
                    name='region'
                    value='all_regions'
                    label='All Regions'
                    checked
                  />
                  <Form.Select id='states-dropdown'></Form.Select>
                </div>
              </div>
            </Collapse>
          </div> */}

          {/* Filter by Categories */}
          <div className="filter-group">
            <div
              className="filter-btn"
              onClick={() => handleGroupCollapse("category")}
            >
              <SpaceDashboard />
              <h4>Categories</h4>
              <KeyboardArrowLeft
                className="chevron"
                style={{
                  transform: collapsed.category ? "rotate(-90deg)" : "unset"
                }}
              />
            </div>

            <Collapse in={collapsed.category}>
              <div>
                <div className="filter-content">
                  {["events", "teams", "clubs", "competitions", "venues"].map(
                    (categoryOption) => (
                      <Form.Check
                        key={categoryOption}
                        type="checkbox"
                        value={categoryOption}
                        label={categoryOption.toUpperCase()}
                        checked={category === categoryOption}
                        onClick={() => onCategoryChange(categoryOption)}
                      />
                    )
                  )}
                </div>
              </div>
            </Collapse>
          </div>

          {/* Filter by Date */}
          <div className="filter-group">
            <div
              className="filter-btn"
              onClick={() => handleGroupCollapse("date")}
            >
              <PendingActions />
              <h4>Date</h4>
              <KeyboardArrowLeft
                className="chevron"
                style={{
                  transform: collapsed.date ? "rotate(-90deg)" : "unset"
                }}
              />
            </div>

            <Collapse in={collapsed.date}>
              <div>
                <div className="filter-content-wide">
                  <Form.Check
                    type="radio"
                    name="time"
                    value="24h"
                    label="Last 24h"
                  />
                  <InputGroup>
                    <span>To:</span>
                    <FormControl
                      value={toDate}
                      onChange={onToDateChange}
                      type="date"
                      className="input-box"
                    />
                  </InputGroup>
                  <InputGroup>
                    <span style={{ marginRight: "7px" }}>From:</span>
                    <FormControl
                      value={fromDate}
                      onChange={onFromDateChange}
                      type="date"
                      className="input-box"
                    />
                  </InputGroup>
                </div>
              </div>
            </Collapse>
          </div>

          <div className="filter-group">
            <div
              className="filter-btn"
              onClick={() => handleGroupCollapse("venue")}
            >
              <Stadium />
              <h4>Venues</h4>
              <KeyboardArrowLeft
                className="chevron"
                style={{
                  transform: collapsed.venue ? "rotate(-90deg)" : "unset"
                }}
              />
            </div>

            <Collapse in={collapsed.venue}>
              <div className="filter-content" style={{ paddingLeft: "0" }}>
                <Form.Select
                  id="favorite-sports"
                  onClick={() => onVenueChange}
                  value={venue}
                >
                  {venues &&
                    venues.map((venue: Venue, index: number) => {
                      return (
                        <option key={index} value={venue?.uuid}>
                          {venue?.name}
                        </option>
                      );
                    })}
                </Form.Select>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </div>
  );
};
